import { Component, ElementRef, OnInit, ViewChild ,Input,Output ,EventEmitter} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



import { Subject } from 'rxjs';


@Component({
    selector: 'create-request-menu',
    templateUrl: './create-request-menu-component.html',
    // styleUrls: ['./create-request-menu-component.css']
})

export class CreateRequestMenuComponent implements OnInit {
    public requestType='';
    public paramType = '';
    public titleName = 'Request List';
    @Input() _activeMenu: string = '';
    @Output() routeTypeEmit= new EventEmitter();
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private activatedRoute: ActivatedRoute,
    ) {

       
       

    }


    ngOnInit(): void {
        this.requestType = this.route.snapshot.paramMap.get('requestType');
// console.log(this.requestType)
    

    }

    pageNavigateAction(requestType?){
        console.log(this.requestType)

       
        if( this.requestType == 'leave-request'){
            this.router.navigate(['/organization/transport-manager/request/add-request/leave_request'  ])
          }
          if( this.requestType =='on-board-request'){
            this.router.navigate(['/organization/transport-manager/request/add-request/on_board_request'  ]);
          }
          if(this.requestType =='custom-request'){
              this.router.navigate(['/organization/transport-manager/request/add-request/custom_request'  ]);
            }
            if(this.requestType =='location-request'){
              this.router.navigate(['/organization/transport-manager/request/add-request/location_request'  ]);
            }
            if(this.requestType =='route-change'){
              this.router.navigate(['/organization/transport-manager/request/add-request/route_change'  ]);
            }
            if(this.requestType =='time-change'){
              this.router.navigate(['/organization/transport-manager/request/add-request/time_change'  ]);
            }
          if(this.requestType =='shift-change'){
              this.router.navigate(['/organization/transport-manager/request/add-request/shift_change'  ]);
            }
            if(this.requestType =='address-update'){
              this.router.navigate(['/organization/transport-manager/request/add-request/address_update'  ]);
            }
            if(this.requestType =='route-request'){
              this.router.navigate(['/organization/transport-manager/request/add-request/route_request'  ]);
            }
            if(this.requestType =='route-cancel'){
              this.router.navigate(['/organization/transport-manager/request/add-request/route_cancel'  ]);
            }
    }
    pageNavigate(path, $event) {

        
        // const urlPath = '/organization/transport-manager/request/add-request';
        
        setTimeout(()=>{
            this.router.navigate([  path]);
        },10);
        // this.router.navigate(['/heroes', { id: heroId }]);
    }
}